
    import { mapActions } from 'vuex';
    import TabBar from '@/components/Utils/TabBar';
    import Tab from '@/components/Utils/Tab';
    import datalayer from '@/utils/datalayer';

    export default {
        name: 'ResumeWritePurchaseOptionStacked',

        components: {
            TabBar,
            Tab,
        },

        props: {
            detectImpression: {
                type: Boolean,
                default: true,
            },
            buyCtaImpressionData: {
                type: Object,
                default: () => {},
            },
            payCtaImpressionData: {
                type: Object,
                default: () => {},
            },
            buyClickData: {
                type: Object,
                default: () => {},
            },
            payClickData: {
                type: Object,
                default: () => {},
            },
        },

        watch: {
            detectImpression(detected) {
                if (detected) {
                    this.buyCtaImpressionEvent();
                }
            },
        },

        methods: {
            ...mapActions('eventTracking', {
                $_pushEvent: 'pushEvent',
            }),
            async pushEvent(data) {
                datalayer(data);
                return await this.$_pushEvent(data).catch(e => undefined);
            },
            async pushEventClick($e, data) {
                const url = $e.currentTarget.getAttribute('href');
                const isShortcutKeyPressed = $e.ctrlKey || $e.shiftKey || $e.metaKey;
                const isMiddleButtonPressed = $e.button === 1;
                const isRightButtonPressed = $e.button === 2;

                if (isRightButtonPressed) {
                    return false;
                }

                const event = await this.pushEvent(data);
                console.log('event', event);

                if (isShortcutKeyPressed || isMiddleButtonPressed) {
                    window.open(url, '_blank');
                } else {
                    window.location.href = url;
                }
            },
            buyCtaImpressionEvent() {
                if (!this.detectImpression) {
                    return false;
                }
                const data = this.buyCtaImpressionData;
                this.pushEvent(data);
            },
            payCtaImpressionEvent() {
                if (!this.detectImpression) {
                    return false;
                }
                const data = this.payCtaImpressionData;
                this.pushEvent(data);
            },
            onSelectedTab(index) {
                const isBuyUpfrontTab = index === 0;
                const is3PaymentTab = index === 1;
                if (isBuyUpfrontTab) {
                    this.buyCtaImpressionEvent();
                } else if (is3PaymentTab) {
                    this.payCtaImpressionEvent();
                }
            },
        },
    };
